/*
 * @Author: 王春岩 <Bolt>
 * @Date:   2016-12-21 16:31:47
 * @Last Modified by:   Bolt
 * @Last Modified time: 2016-12-21 16:39:00
 */

'use strict';

import './index.less';

(function() {
    var $ = window.$;
    $(document).ready(function() {
        var c = {
            height: 145
        };

        if (window._qiwa && window._qiwa.__site_basic.siteId === '233') {
            c.height = 87;
        }

        $('.advisor-tip-close').click(function(e) {
            e.preventDefault();
            $('.my-advisor-tip').addClass('hidden');
            $('#advisor_notice').addClass('hidden');
            $.cookie('f2e_guwen_close', '1', {
                expires: 1
            });
            e.stopPropagation();
        });
        var siderbarShow = false;
        var showSidebar = function(self) {

            $('.sidebar .side-box').removeClass('active');
            $(self.parentNode).addClass('active');
            if (!$('#toolbar').hasClass('sidebar-active')) {
                $('#toolbar').animate({
                    width: 905,
                    height: ($(window).height() - 20) > 500 ? 500 : ($(window).height() - 20)
                }, 500, function() {
                    siderbarShow = true;
                });
                $('.sidebar  iframe').css({
                    height: (($(window).height() - 20) > 500 ? 500 : ($(window).height() - 20)) - 32
                });
                $('#toolbar').addClass('sidebar-active');
                $('.sidebar').removeClass('active');
            }
            $('.toolbar-content iframe').attr('src', $(self).attr('href'));
            $('.toolbar-content .iframe-loading').removeClass('hidden');
            $('.toolbar-content iframe').load(function() {
                $(this).removeClass('hidden');
                $('.toolbar-content .iframe-loading').addClass('hidden');
            });
        };
        $('.sidebar').click(function(e) {
            e.stopPropagation();
        });
        $('.sidebar .side-trigger').click(function(e) {

            var self = this;
            if ($(this).hasClass('collect-box')) {
                e.preventDefault();
                showSidebar(self);
            }
        });
        $('#my-advisor').on('mouseenter', function() {
            $('#my-advisor').addClass('active');
        }).mouseleave(function() {
            $('#my-advisor').removeClass('active');
        });

        $('.sidebar').on('mouseenter', function() {
            if (!$('.sidebar').hasClass('sidebar-active')) {
                $('.sidebar').addClass('active');
            }
        }).mouseleave(function() {
            $('.sidebar').removeClass('active');
        });
        $('.toolbar-close').click(function() {
            $('#toolbar').animate({
                width: 52,
                height: c.height
            }, 500, function() {

            });
            $('#toolbar').removeClass('sidebar-active');
            siderbarShow = false;
        });
        $(document.body).click(function() {
            if (siderbarShow) {
                $('#toolbar').animate({
                    width: 52,
                    height: c.height
                }, 500, function() {});
                $('#toolbar').removeClass('sidebar-active');
                siderbarShow = false;
            }

        });
        $('#noreg-popup').on('click', function(e) {
            e.stopPropagation();
        });
        $(window).scroll(function() {
            if ($(window).scrollTop() > 0) {

                $('#toTop').show('slow');
            } else {
                $('#toTop').hide('slow');
            }
        });
        $('#toTop').click(function() {
            $('html,body').animate({
                scrollTop: 0
            });
        });
    });
})();



// WEBPACK FOOTER //
// ./src/modules/toolbar/index.js